const transactionPattern =
  /^\/mcp\/authorize\?transaction=[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const reviewPattern =
  /^\/mcp\/copublicity\/review\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function getMcpReturnTo(value: string | null | undefined): string | null {
  return value && (transactionPattern.test(value) || reviewPattern.test(value)) ? value : null;
}

export function getLoginReturnPath(params: URLSearchParams): string {
  const value = params.get('returnTo');
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\s]/.test(value))
    return '/dashboard';
  if (value.startsWith('/mcp')) return getMcpReturnTo(value) ?? '/dashboard';
  return value;
}
